export const POWER_RANGE = 15;
